import React from 'react';
import styled from 'styled-components';
import {
  StrapiTextual,
  StrapiTextualProps,
} from '@/features/strapi/components/textual';
import { VSpace } from '@/components/spacing';
import { breakpoints } from '@/components/responsive';

export interface StrapiFeatureCardProps {
  title: StrapiTextualProps;
  description?: StrapiTextualProps;
  image: any;
  mobileImage: any;
  width?: string;
}

export function StrapiFeatureCard({
  title,
  description,
  image,
  mobileImage,
  width,
}: StrapiFeatureCardProps) {
  return (
    <Wrapper width={width}>
      <StrapiTextual className="title" {...title} />
      {description && (
        <>
          <VSpace value={3} xlrValue={4} />
          <StrapiTextual className="description" {...description} />
        </>
      )}
      <img className="only-mobile" src={mobileImage} alt="" />
      <img className="only-desktop" src={image} alt="" />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: block;
  flex-direction: column;
  position: relative;
  border: 1px solid rgba(151, 151, 151, 0.05);
  border-radius: 3rem;
  background-color: #f7f9fb;
  padding: 4rem;
  min-height: 40rem;
  width: ${(props: StrapiFeatureCardProps) => props.width || `auto`};
  overflow: hidden;

  ${breakpoints.down(369)} {
    width: 93%;
  }

  ${breakpoints.down(`md`)} {
    border-radius: 2rem;
    min-height: 32.5rem;
    margin: 0 auto;
  }

  ${breakpoints.up(`xlr`)} {
    padding: 6rem 5rem;
    width: calc(
      ${(props: StrapiFeatureCardProps) => props.width || `auto`} * 1.3
    );
    min-height: calc(40rem * 1.28);
  }

  ${breakpoints.up(`xl`)} {
    padding: 6rem 5rem;
    width: calc(
      ${(props: StrapiFeatureCardProps) => props.width || `auto`} * 1.4
    );
    min-height: calc(40rem * 1.38);
  }

  ${breakpoints.up(`xxl`)} {
    width: calc(
      ${(props: StrapiFeatureCardProps) => props.width || `auto`} * 1.86
    );
    min-height: calc(40rem * 1.84);
    padding: 8rem;
  }

  .title {
    position: relative;
    z-index: 3 !important;
    background: black;
    color: white;
    padding: 1rem 2rem;
    border-radius: 3rem;

    ${breakpoints.up(`xlr`)} {
      font-size: 2.5rem;
      padding: 2rem 4rem;
      border-radius: 4rem;
    }

    ${breakpoints.up(`xxl`)} {
      font-size: 3.5rem;
      padding: 2rem 4rem;
      border-radius: 4rem;
    }
  }

  .description {
    line-height: 1.8;
    ${breakpoints.up(`xlr`)} {
      font-size: 2.4rem;
    }

    ${breakpoints.up(`xxl`)} {
      font-size: 3.5rem;
    }
  }

  img {
    position: absolute;
    height: 100%;
    width: 100%;

    margin: 0 auto;
    bottom: 0;
    right: 0;
    object-fit: contain;
    object-position: right center;
    border: none;

    ${breakpoints.down(`md`)} {
      right: -1rem;
    }
  }
`;
